import { P, Section } from '@vp/swan';
import { scrollToElementById } from '@99designs/browser';
import { SupportedLocale, __ } from '@99designs/i18n';
import { Category } from '../../types';
import { DesignCategories } from '../DesignCategories';
import { FAQ } from '../FAQ';
import { HowItWorks } from '../HowItWorks';
import { PackagingDesignBanner } from '../PackagingDesignBanner';
import { PackagingDoubleBanner } from '../PackagingDoubleBanner';
import { PackagingSampleBanner } from '../PackagingSampleBanner';
import { PopularProducts } from '../PopularProducts';
import { VistaValueProposition } from '../VistaValueProposition';

interface PackagingMainContentProps {
    locale: SupportedLocale;
    category: Category | null;
    selectedCategoryId?: string;
}

const DesignCategoriesSectionId = 'design-categories-section';
const HowItWorksSectionId = 'how-it-works-section';
const ScrollTopMargin = 75;

export function PackagingMainContent({
    locale,
    category,
    selectedCategoryId,
}: PackagingMainContentProps) {
    const productGroups = category?.productGroups;
    const popularProducts = category?.popularProducts;

    return (
        <>
            <Section marginBottom="between-sections" style={{ boxShadow: 'none' }}>
                <PackagingDesignBanner
                    browseDesignServicesCtaOnClick={() => {
                        scrollToElementById(DesignCategoriesSectionId, ScrollTopMargin);
                    }}
                    howItWorksCtaOnClick={() => {
                        scrollToElementById(HowItWorksSectionId, ScrollTopMargin);
                    }}
                />
            </Section>
            <Section marginBottom="between-sections" style={{ boxShadow: 'none' }}>
                <VistaValueProposition />
            </Section>
            {productGroups && productGroups.length > 0 ? (
                <Section
                    marginBottom="between-sections"
                    id={DesignCategoriesSectionId}
                    style={{ boxShadow: 'none' }}
                >
                    <DesignCategories
                        title={__('All packaging design services', {
                            _context:
                                'The title for a section on a landing page displaying design services',
                        })}
                        categories={productGroups}
                        locale={locale as SupportedLocale}
                        initialCategoryId={selectedCategoryId}
                    />
                </Section>
            ) : (
                <Section
                    marginBottom="between-sections"
                    id={DesignCategoriesSectionId}
                    style={{ boxShadow: 'none' }}
                >
                    <P textAlign="center">
                        {__(
                            'Whoops - design categories could not be loaded but we are working on it.',
                            {
                                _context:
                                    'An error message displayed on a landing page when a component containing design categories cannot be loaded correctly',
                            }
                        )}
                    </P>
                </Section>
            )}
            {popularProducts && popularProducts.length > 0 && (
                <Section marginBottom="between-sections" style={{ boxShadow: 'none' }}>
                    <PopularProducts
                        products={popularProducts}
                        locale={locale as SupportedLocale}
                        title={__('Popular packaging design services')}
                    />
                </Section>
            )}
            <Section style={{ boxShadow: 'none' }} id={HowItWorksSectionId}>
                <HowItWorks hideCTA locale={locale} />
            </Section>
            <Section marginBottom="between-sections" style={{ boxShadow: 'none' }}>
                <PackagingSampleBanner />
            </Section>
            <Section marginBottom="between-sections" style={{ boxShadow: 'none' }}>
                <FAQ />
            </Section>
            <Section style={{ boxShadow: 'none' }}>
                <PackagingDoubleBanner />
            </Section>
        </>
    );
}
